import React, { useState } from "react";
import {
  Dialog,
  Button,
  DialogTitle,
  DialogActions,
  Box,
  Typography,
  DialogContent,
  DialogContentText,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { logEventos } from "../../../services/services";
import { UrlApi } from "../../../services/apirest";

const RechazarCandidatos = ({
  obtenerCandidatos,
  open,
  onClose,
  mostrarAlertaTemporal,
  id_candidato,
}) => {
  const [motivo, setMotivo] = useState("");

  const user = localStorage.getItem("user");

  const handleSubmit = async () => {
    logEventos(
      "Rechanzando un candidato de una solicitud",
      "Solicitud de trabajo",
      "Rechanzando un candidato de una solicitud",
      localStorage.getItem("user")
    );

    if (motivo?.length === 0) {
      mostrarAlertaTemporal(
        "Completa el campo motivo antes de enviar",
        "error"
      );
      return;
    } else if (motivo?.trim().length < 10) {
      mostrarAlertaTemporal(
        "El motivo debe tener como mínimo 10 caracteres",
        "error"
      );
      return;
    }
    const solicitudMotivo = {
      id_candidato,
      motivo: "Rechazado antes de ser seleccionado - " + motivo,
      user,
    };

    try {
      const response = await fetch(`${UrlApi}/SP_motivos`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(solicitudMotivo),
      });

      if (!response.ok) {
        const messageError = await response.json();
        mostrarAlertaTemporal(
          messageError.message || "Ocurrió un error inesperado",
          "error"
        );
        onClose();
      }
    } catch (err) {
      console.error("Error al realizar la solicitud:", err);
      mostrarAlertaTemporal(
        "Ocurrió un problema. Intente nuevamente.",
        "error"
      );
      onClose();
    }

    try {
      const responsePut = await fetch(
        `${UrlApi}/SP_candidatos/${id_candidato}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ estado: 0 }),
        }
      );

      if (!responsePut.ok) {
        const errorMessagePut = await responsePut.json();
        mostrarAlertaTemporal(
          errorMessagePut.message || "Ocurrió un error inesperado",
          "error"
        );
        onClose();
      }
    } catch (err) {
      console.error("Error al realizar la solicitud:", err);
      mostrarAlertaTemporal(
        "Ocurrió un problema. Intente nuevamente.",
        "error"
      );
      onClose();
    }
    mostrarAlertaTemporal(
      "La solicitud se actualizó correctamente!",
      "success"
    );
    await obtenerCandidatos();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <Box justifyContent="center" backgroundColor="#1F618D">
        <DialogTitle>
          <Box component="div">
            <Typography
              variant="h6"
              align="left"
              color="#ffffff"
              sx={{ fontWeight: "bold" }}
            >
              Rechazar candidato
            </Typography>
          </Box>
        </DialogTitle>
      </Box>
      <DialogContent>
        <DialogContentText textAlign={"left"}>
          <Typography variant="p" align="left" color="#1c1c1c">
            Debe indicar el motivo por el que el candidato decidio rechazar la
            propuesta
          </Typography>
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          value={motivo}
          onChange={(e) => setMotivo(e.target.value)}
          id="motivo"
          label="Motivo"
          type="text"
          fullWidth
          multiline
          rows={2}
          inputProps={{ maxLength: 70 }}
        />
        <Typography variant="body2" color="textSecondary">
          {motivo?.length || 0} / 70 caracteres
        </Typography>
      </DialogContent>

      <DialogActions>
        <Grid
          container
          direction="row"
          justifyContent="end"
          alignItems="center"
          gap={3}
          marginRight={2}
        >
          <Button
            variant="contained"
            onClick={onClose}
            style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
          >
            Volver
          </Button>
          <Button
            style={{ color: "#ffffff" }}
            type="submit"
            onClick={handleSubmit}
            variant="contained"
            color="primary"
          >
            Confirmar
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default RechazarCandidatos;
